module.exports = __webpack_public_path__ + "static/media/dyer_richard.aaa2ec6a.jpg";